// LoadingScreen.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import sealuminatiLogo from '../assets/sealuminati_laser.gif';
// Install lottie-react: npm install lottie-react (or yarn add lottie-react)
import Lottie from 'lottie-react';
// Replace the path below with the correct path to your Enter.json
import enterAnimation from '../assets/Enter.json';

const LoadingScreen = ({ onLoadingComplete }) => {
    const navigate = useNavigate();

    const handleEnterClick = () => {
        if (onLoadingComplete) {
            onLoadingComplete();
        }
        navigate('/');
    };

    return (
        <div className="flex flex-col justify-start items-center w-screen min-h-screen bg-black overflow-hidden select-none">
            <img
                src={sealuminatiLogo}
                alt="Loading..."
                className="
          w-full
          max-h-[80vh]
          sm:max-w-7xl
          sm:max-h-[100vh]
          object-contain
          z-50
        "
            />

            {/* Button wrapping the Lottie animation so the animation is clickable */}
            <button
                onClick={handleEnterClick}
                className="
          mt-4
          md:-mt-32
          px-6 py-3
          rounded-md
          hover:opacity-90
          focus:outline-none
          focus:ring-2
          focus:ring-gray-200
          font-um
          z-50
        "
            >
                {/* You can adjust width/height or use Tailwind classes for responsive sizing */}
                <div className="w-32 sm:w-48">
                    <Lottie
                        animationData={enterAnimation}
                        loop={false}
                        autoPlay
                    />
                </div>
            </button>
        </div>
    );
};

export default LoadingScreen;
